import React from 'react';
import {motion} from 'framer-motion';
import {Text} from '@tenancy.nz/design-system';
import Link from './Link';

import {URL_PRIVACY_POLICY} from '../utils/constants';

function AboutContent() {
  const animateProps = {
    initial: {opacity: 0, y: 20},
    animate: {opacity: 1, y: 0},
  };
  return (
    <Text as="div">
      <motion.p {...animateProps} transition={{delay: 0.15}}>
        Your Tenant Profile will help you apply for tenancies without having to
        re-enter all your information every time.
      </motion.p>
      <motion.p {...animateProps} transition={{delay: 0.25}}>
        We want YOU to be able to access and use your own data to benefit you.
        This is why we are working on a full transparency project where you will
        be able to see your credit files and track where in the Application
        process your application is.
      </motion.p>
      <motion.p {...animateProps} transition={{delay: 0.35}}>
        Our core philosophy is to help people with the services we provide, in a
        way that everybody wins.
      </motion.p>
      <motion.p {...animateProps} transition={{delay: 0.45}}>
        He aha te mea nui o te ao
        <br />
        What is the most important thing in the world?
        <br />
        He tangata, he tangata, he tangata
        <br />
        It is the people, it is the people, it is the people
        <br />- Maori proverb
      </motion.p>
      <motion.p {...animateProps} transition={{delay: 0.55}}>
        To view our Privacy Policy, click{' '}
        <Link to={URL_PRIVACY_POLICY}>here</Link>
      </motion.p>
    </Text>
  );
}

export default AboutContent;
